import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).modal({ closable: true }).modal("show")
    this.removeEmailReminderParam()
  }

  close() {
    $(this.element).modal("hide")
  }

  removeEmailReminderParam() {
    const url = new URL(window.location)
    url.searchParams.delete("show_email_reminder")
    window.history.replaceState(history.state, "", url)
  }
}
